/* "Make it a set" under the buy buttons (this piece + its best match, added together in one tap,
   with three other matches to swap in), and the "Complete the look" sheet that slides up after
   a shopper adds this product and closes the cart.
   The picks come from window.MBLook (assets/mb-pdp.js).
   Also shows the "Buy any 2, get 10% off" offer (applied by FlexyPe at checkout),
   worded by how many pieces are already in the cart. */
(function () {
  if (window.__mbPairs) return;
  window.__mbPairs = true;

  var STRIP_COUNT = 4;
  var SHEET_COUNT = 6;
  var stripUsed = false;
  var dataPromise = null;

  /* ---------- Buy any 2 offer ---------- */
  var OFFER_QTY = 2;
  var OFFER_PCT = 10;
  var cartCount = null;
  function refreshCount() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartCount = c.item_count || 0;
        renderOffer();
        return cartCount;
      })
      .catch(function () { return cartCount || 0; });
  }
  var countTimer = null;
  function refreshSoon() {
    clearTimeout(countTimer);
    countTimer = setTimeout(refreshCount, 400);
  }
  /* Refresh after any cart change made on the page, by us, Dawn or FlexyPe. */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refreshSoon, refreshSoon);
      return p;
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshSoon(); });

  function offerLine() {
    var box = document.querySelector('[data-mb-offer]');
    if (box) return box;
    var price = document.querySelector('.product__info-container [id^="price-"]');
    if (!price) return null;
    box = document.createElement('p');
    box.className = 'mb-offer';
    box.setAttribute('data-mb-offer', '');
    box.setAttribute('aria-live', 'polite');
    price.parentNode.insertBefore(box, price.nextSibling);
    return box;
  }
  var TAG = '<svg class="mb-offer__icon" viewBox="0 0 20 20" aria-hidden="true"><path d="M10.6 2.5H16a1.5 1.5 0 0 1 1.5 1.5v5.4a1.5 1.5 0 0 1-.44 1.06l-6.6 6.6a1.5 1.5 0 0 1-2.12 0L2.94 11.66a1.5 1.5 0 0 1 0-2.12l6.6-6.6A1.5 1.5 0 0 1 10.6 2.5Z" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="13.6" cy="6.4" r="1.4" fill="currentColor"/></svg>';
  var TICK = '<svg class="mb-offer__icon" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m6.3 10.2 2.5 2.5 4.9-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function renderOffer() {
    var box = offerLine();
    var n = cartCount || 0;
    if (box) {
      var html;
      if (n >= OFFER_QTY) {
        html = TICK + '<span><b>' + OFFER_PCT + '% off unlocked</b> on your order. Applied at checkout.</span>';
      } else if (n === OFFER_QTY - 1) {
        html = TAG + '<span>Add <b>1 more piece</b> to get <b>' + OFFER_PCT + '% off</b>. It can be this one again.</span>';
      } else {
        html = TAG + '<span><b>Buy any ' + OFFER_QTY + ', get ' + OFFER_PCT + '% off.</b> Applied automatically at checkout.</span>';
      }
      box.innerHTML = html;
      box.classList.toggle('mb-offer--done', n >= OFFER_QTY);
    }
    var t = document.querySelector('[data-mb-pairs] .mb-pairs__title');
    if (t) t.textContent = n === OFFER_QTY - 1 ? 'Make it a set & save ' + OFFER_PCT + '%' : (setState ? 'Make it a set' : 'Pairs well with');
    if (setState) setTotal();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shortTitle(t) {
    return t.split('|')[0].split(' – ')[0].split(' - ')[0].replace(/\s+/g, ' ').trim();
  }
  function getData() {
    if (dataPromise) return dataPromise;
    if (!window.MBLook) return Promise.resolve([]);
    dataPromise = window.MBLook.ids()
      .then(function (ids) { return window.MBLook.mini(ids.slice(0, 10)); })
      .then(function (list) {
        /* Items that can be added straight away first. */
        return list.filter(function (d) { return d.available; })
          .concat(list.filter(function (d) { return !d.available; }));
      })
      .catch(function () { return []; });
    return dataPromise;
  }
  function card(d) {
    var title = esc(shortTitle(d.title));
    var action;
    if (!d.available) action = '<span class="mb-mini__sold">Sold out</span>';
    else if (d.multi) action = '<a class="mb-mini__add" href="' + esc(d.url) + '">Choose</a>';
    else action = '<button type="button" class="mb-mini__add" data-mb-add="' + esc(d.variant) + '" aria-label="Add ' + title + ' to cart">Add</button>';
    return '<li class="mb-mini">' +
      '<a class="mb-mini__img" href="' + esc(d.url) + '" tabindex="-1" aria-hidden="true">' +
        (d.img ? '<img src="' + esc(d.img) + '" width="320" height="400" loading="lazy" alt="">' : '') +
      '</a>' +
      '<a class="mb-mini__title" href="' + esc(d.url) + '">' + title + '</a>' +
      '<div class="mb-mini__price">' + esc(d.price) + (d.compare ? '<s>' + esc(d.compare) + '</s>' : '') + '</div>' +
      action +
    '</li>';
  }

  /* Add to cart. FlexyPe opens its cart drawer by itself after an add. */
  function addToCart(btn) {
    var id = Number(btn.getAttribute('data-mb-add'));
    if (!id || btn.disabled) return;
    if (btn.closest('[data-mb-pairs]')) stripUsed = true;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    closeSheet();
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        setTimeout(function () {
          if (!document.body.classList.contains('flexype-cart-dialog-open')) openCart();
        }, 1200);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  }
  function openCart() {
    if (window.FlexyPeCart && typeof window.FlexyPeCart.open === 'function') {
      try { window.FlexyPeCart.open(); return; } catch (e) {}
    }
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.click();
    else window.location.href = '/cart';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mb-add]') : null;
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---------- Make it a set ---------- */
  var setState = null;
  function num(price) { return parseFloat(String(price).replace(/[^0-9.]/g, '')) || 0; }
  function money(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function currentVariant() {
    var input = document.querySelector('.product__info-container form[action*="/cart/add"] [name="id"]');
    return input && input.value ? Number(input.value) : 0;
  }
  function setItem(d, role) {
    var title = esc(shortTitle(d.title));
    return '<label class="mb-set__item">' +
      '<input type="checkbox" class="mb-set__check" data-mb-set-check="' + role + '" checked>' +
      '<span class="mb-set__tick" aria-hidden="true"></span>' +
      (d.img ? '<img class="mb-set__img" src="' + esc(d.img) + '" width="160" height="200" loading="lazy" alt="">' : '<span class="mb-set__img"></span>') +
      '<span class="mb-set__info">' +
        '<span class="mb-set__name">' + (role === 'me' ? '<b>This piece:</b> ' : '') + title + '</span>' +
        '<span class="mb-set__price">' + esc(d.price) + (d.compare ? ' <s>' + esc(d.compare) + '</s>' : '') + '</span>' +
      '</span>' +
    '</label>';
  }
  function altCard(d) {
    var title = esc(shortTitle(d.title));
    return '<li class="mb-mini">' +
      '<a class="mb-mini__img" href="' + esc(d.url) + '" tabindex="-1" aria-hidden="true">' +
        (d.img ? '<img src="' + esc(d.img) + '" width="320" height="400" loading="lazy" alt="">' : '') +
      '</a>' +
      '<a class="mb-mini__title" href="' + esc(d.url) + '">' + title + '</a>' +
      '<div class="mb-mini__price">' + esc(d.price) + (d.compare ? '<s>' + esc(d.compare) + '</s>' : '') + '</div>' +
      '<button type="button" class="mb-mini__add" data-mb-swap="' + esc(d.id) + '" aria-label="Swap ' + title + ' into the set">Swap in</button>' +
    '</li>';
  }
  function setTotal() {
    var box = document.querySelector('[data-mb-pairs]');
    if (!box || !setState) return;
    var me = box.querySelector('[data-mb-set-check="me"]').checked;
    var mate = box.querySelector('[data-mb-set-check="mate"]').checked;
    var count = (me ? 1 : 0) + (mate ? 1 : 0);
    var sum = (me ? num(setState.me.price) : 0) + (mate ? num(setState.mate.price) : 0);
    var line = box.querySelector('[data-mb-set-total]');
    var btn = box.querySelector('[data-mb-set-add]');
    if (!count) {
      line.innerHTML = 'Tick a piece to add it.';
    } else if (count + (cartCount || 0) >= OFFER_QTY) {
      line.innerHTML = (count === 2 ? 'Together ' : '') + '<b>' + money(sum) + '</b> · <span class="mb-set__save">you save about ' + money(sum * OFFER_PCT / 100) + ' with Buy any ' + OFFER_QTY + '</span>';
    } else {
      line.innerHTML = '<b>' + money(sum) + '</b> · add both to get ' + OFFER_PCT + '% off';
    }
    /* Keep the "Added" state on the button after the cart count refreshes. */
    if (setState.added) return;
    btn.disabled = !count;
    btn.textContent = count === 2 ? 'Add both to cart' : 'Add to cart';
  }
  function drawSet(box, swapped) {
    var s0 = setState;
    box.innerHTML =
      '<p class="mb-pairs__title">Make it a set</p>' +
      '<div class="mb-set">' +
        setItem(s0.me, 'me') +
        '<span class="mb-set__plus" aria-hidden="true">+</span>' +
        setItem(s0.mate, 'mate') +
        (swapped ? '<p class="mb-set__swapped" role="status">✓ Swapped in. Tap Add both to cart.</p>' : '') +
        '<p class="mb-set__total" data-mb-set-total aria-live="polite"></p>' +
        '<button type="button" class="mb-set__add" data-mb-set-add>Add both to cart</button>' +
      '</div>' +
      (s0.alts.length ? '<p class="mb-set__more">Or swap in one of these</p><ul class="mb-mini-list" role="list">' + s0.alts.map(altCard).join('') + '</ul>' : '');
    box.hidden = false;
    renderOffer();
  }
  function strip() {
    var box = document.querySelector('[data-mb-pairs]');
    if (!box) return;
    var meId = window.MBLook && window.MBLook.el() ? window.MBLook.el().getAttribute('data-product-id') : '';
    Promise.all([getData(), meId && window.MBLook ? window.MBLook.mini([meId]) : Promise.resolve([])]).then(function (res) {
      var list = res[0];
      var me = res[1][0];
      var addable = list.filter(function (d) { return d.available && !d.multi; });
      if (me && me.available && addable.length >= 1) {
        setState = { me: me, mate: addable[0], alts: addable.slice(1, STRIP_COUNT) };
        drawSet(box);
        return;
      }
      /* This piece is sold out or nothing can be added in one tap: plain strip. */
      var picks = list.slice(0, STRIP_COUNT);
      if (picks.length < 2) return;
      box.querySelector('.mb-mini-list').innerHTML = picks.map(card).join('');
      box.hidden = false;
      renderOffer();
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mb-set-check]')) setTotal();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var swap = t.closest('[data-mb-swap]');
    if (swap && setState) {
      e.preventDefault();
      var id = swap.getAttribute('data-mb-swap');
      var i = -1;
      setState.alts.forEach(function (d, k) { if (String(d.id) === id) i = k; });
      if (i < 0) return;
      setState.added = false;
      var old = setState.mate;
      setState.mate = setState.alts[i];
      setState.alts[i] = old;
      var box = document.querySelector('[data-mb-pairs]');
      drawSet(box, true);
      var set = box.querySelector('.mb-set');
      if (set) {
        set.classList.add('mb-set--flash');
        /* Bring the set into view (below the sticky header) so the change is seen. */
        var r = set.getBoundingClientRect();
        var head = document.querySelector('sticky-header, .header-wrapper');
        var top = (head ? Math.max(0, head.getBoundingClientRect().bottom) : 0) + 10;
        if (r.top < top || r.bottom > window.innerHeight) window.scrollBy({ top: r.top - top, behavior: 'smooth' });
        setTimeout(function () { set.classList.remove('mb-set--flash'); }, 1600);
      }
      return;
    }
    var add = t.closest('[data-mb-set-add]');
    if (add && setState && !add.disabled) {
      e.preventDefault();
      var box2 = document.querySelector('[data-mb-pairs]');
      var items = [];
      if (box2.querySelector('[data-mb-set-check="me"]').checked) items.push({ id: currentVariant() || Number(setState.me.variant), quantity: 1 });
      if (box2.querySelector('[data-mb-set-check="mate"]').checked) items.push({ id: Number(setState.mate.variant), quantity: 1 });
      if (!items.length) return;
      stripUsed = true;
      add.disabled = true;
      add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          setState.added = true;
          add.textContent = items.length === 2 ? 'Added both ✓' : 'Added ✓';
          add.classList.add('is-added');
          setTimeout(function () {
            if (!document.body.classList.contains('flexype-cart-dialog-open')) openCart();
          }, 1200);
        })
        .catch(function () {
          add.disabled = false;
          add.textContent = 'Try again';
        });
    }
  });

  /* ---------- Sheet ---------- */
  var sheet = null;
  var lastFocus = null;
  function productId() {
    var el = window.MBLook && window.MBLook.el();
    return el ? el.getAttribute('data-product-id') : location.pathname;
  }
  function seen() {
    try { return sessionStorage.getItem('mb_look_sheet:' + productId()) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem('mb_look_sheet:' + productId(), '1'); } catch (e) {}
  }
  function buildSheet(list) {
    var titleEl = document.querySelector('.product__title h1, .product__title');
    var name = titleEl ? shortTitle(titleEl.textContent) : '';
    var wrap = document.createElement('div');
    wrap.className = 'mb-sheet';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="mb-sheet__backdrop" data-mb-close></div>' +
      '<div class="mb-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="mbSheetTitle" tabindex="-1">' +
        '<div class="mb-sheet__grip" aria-hidden="true"></div>' +
        '<button type="button" class="mb-sheet__x" data-mb-close aria-label="Close">&times;</button>' +
        '<p class="mb-sheet__ok"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="#1d7a3d"/><path d="m6 10.3 2.6 2.6L14.2 7.4" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Added to your cart</p>' +
        '<h2 class="mb-sheet__title" id="mbSheetTitle">Complete the look</h2>' +
        '<div class="mb-sheet__goal" data-mb-goal hidden><div class="mb-sheet__bar"><span></span></div><span class="mb-sheet__goal-text"></span></div>' +
        '<p class="mb-sheet__sub" data-mb-sub data-name="' + esc(name) + '"></p>' +
        '<ul class="mb-mini-list" role="list">' + list.map(card).join('') + '</ul>' +
        '<div class="mb-sheet__actions">' +
          '<button type="button" class="mb-sheet__cart" data-mb-cart>View cart &amp; checkout</button>' +
          '<button type="button" class="mb-sheet__later" data-mb-close>Keep browsing</button>' +
        '</div>' +
      '</div>';
    wrap.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-mb-close]')) { closeSheet(); return; }
      if (t.closest('[data-mb-cart]')) { closeSheet(); openCart(); }
    });
    document.body.appendChild(wrap);
    return wrap;
  }
  function onKey(e) {
    if (e.key === 'Escape') closeSheet();
  }
  function sheetHead() {
    var n = cartCount || 0;
    var title = sheet.querySelector('.mb-sheet__title');
    var goal = sheet.querySelector('[data-mb-goal]');
    var sub = sheet.querySelector('[data-mb-sub]');
    var name = sub.getAttribute('data-name');
    var go = name ? 'to go with ' + esc(name) : 'to go with it';
    if (n > 0 && n < OFFER_QTY) {
      title.textContent = 'Add ' + (OFFER_QTY - n) + ' more & get ' + OFFER_PCT + '% off';
      goal.hidden = false;
      goal.querySelector('.mb-sheet__bar span').style.width = Math.round(n / OFFER_QTY * 100) + '%';
      goal.querySelector('.mb-sheet__goal-text').textContent = n + ' of ' + OFFER_QTY + ' pieces';
      sub.innerHTML = 'Pick any piece. The discount applies automatically at checkout.';
    } else {
      title.textContent = 'Complete the look';
      goal.hidden = true;
      sub.innerHTML = n >= OFFER_QTY
        ? '<b class="mb-sheet__won">Your ' + OFFER_PCT + '% off is unlocked.</b> More pieces chosen ' + go + '.'
        : 'More pieces chosen ' + go + '.';
    }
  }
  function openSheet(list) {
    if (!sheet) sheet = buildSheet(list);
    sheetHead();
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.classList.add('mb-sheet-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sheet.classList.add('mb-sheet--open');
        var panel = sheet.querySelector('.mb-sheet__panel');
        if (panel) panel.focus({ preventScroll: true });
      });
    });
    document.addEventListener('keydown', onKey);
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('mb-sheet--open');
    document.body.classList.remove('mb-sheet-open');
    document.removeEventListener('keydown', onKey);
    var s = sheet;
    setTimeout(function () { s.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* Show the sheet once the shopper has added THIS product and closed the cart. */
  var pending = 0;
  var drawerSeen = false;
  function maybeShow() {
    if (!pending) return;
    var age = Date.now() - pending;
    pending = 0;
    drawerSeen = false;
    /* Skip it if the shopper already added from the strip. */
    if (age > 120000 || seen() || stripUsed) return;
    Promise.all([getData(), refreshCount()]).then(function (res) {
      var list = res[0];
      /* Only pieces "Make it a set" (or the strip) is not already showing. */
      var shown = {};
      if (setState) [setState.mate].concat(setState.alts).forEach(function (d) { shown[d.id] = 1; });
      var picks = setState
        ? list.filter(function (d) { return !shown[d.id]; }).slice(0, SHEET_COUNT)
        : list.slice(STRIP_COUNT, STRIP_COUNT + SHEET_COUNT);
      if (picks.length < 2) return;
      markSeen();
      openSheet(picks);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.product-form__submit, .sticky-atc__button') : null;
    if (!b || b.disabled) return;
    if (b.closest('.mb-sheet, [data-mb-pairs], quick-add-modal, .quick-add-modal, .card-wrapper, .card, product-recommendations, .mb-row')) return;
    if (seen() || stripUsed) return;
    pending = Date.now();
    drawerSeen = false;
    getData();
    /* If the cart drawer never opens, show the sheet anyway. */
    setTimeout(function () {
      if (pending && !drawerSeen && !document.body.classList.contains('flexype-cart-dialog-open')) maybeShow();
    }, 3500);
  }, true);
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      var open = document.body.classList.contains('flexype-cart-dialog-open');
      if (!open) refreshSoon();
      if (open && pending) drawerSeen = true;
      else if (!open && drawerSeen && pending) setTimeout(maybeShow, 350);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* The random "people checking" counter is hidden (mb-global). Show only the real
     low-stock warning, when the page has one. */
  (function stockLine() {
    var c = document.getElementById('fake-view-counter');
    if (!c) return;
    var m = c.textContent.match(/(\d+)\s*stock left/i);
    var w = c.closest('.productView-moreItem');
    if (!m || !w) return;
    var t = c.querySelector('.text');
    if (t) t.innerHTML = '<span id="viewer-count" hidden></span>Only ' + m[1] + ' left in stock, order soon';
    w.classList.add('mb-stock-on');
  })();

  /* Offer line straight away (it sits above the buttons, so no late jump), then the real count. */
  renderOffer();
  refreshCount();

  function start() {
    var go = function () { strip(); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2500 });
    else setTimeout(go, 1200);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
